var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlobFilled = function SvgBlobFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.675 2.758A11.94 11.94 0 0 0 10.474.1 12 12 0 0 0 12.018 24H19a5.006 5.006 0 0 0 5-5v-7.754a12.05 12.05 0 0 0-4.325-8.488"
  })));
};
export default SvgBlobFilled;